.root {
  padding: 4px 0;
}

.toolbar {
  margin-bottom: 8px;
}

.addButton {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--bs-border-color, #dee2e6);
  background-color: transparent;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 0.85rem;
  color: var(--bs-body-color, #212529);
  cursor: pointer;
}
.addButton:hover {
  background-color: rgba(127, 127, 127, 0.12);
}

.palette {
  margin-bottom: 8px;
}

.paletteHint {
  font-size: 0.75rem;
  opacity: 0.7;
  margin-bottom: 4px;
}

.paletteChips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: rgba(127, 127, 127, 0.14);
  color: var(--bs-body-color, #212529);
  font-size: 0.8rem;
  cursor: grab;
  user-select: none;
  touch-action: none;
}

.chipName {
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.canvas {
  position: relative;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 4px;
}

.axis {
  position: relative;
  height: 20px;
  border-bottom: 1px solid var(--bs-border-color, #dee2e6);
}

.tick {
  position: absolute;
  top: 0;
  height: 20px;
  border-left: 1px solid var(--bs-border-color, #dee2e6);
}

.tickMinor {
  position: absolute;
  bottom: 0;
  height: 4px;
  border-left: 1px solid var(--bs-border-color, #dee2e6);
}

.tickLabel {
  position: absolute;
  top: 2px;
  left: 4px;
  font-size: 0.62rem;
  opacity: 0.6;
  white-space: nowrap;
}

.markerStrip {
  position: relative;
  border-bottom: 1px dashed var(--bs-border-color, #dee2e6);
}

.lane {
  position: relative;
  border-bottom: 1px solid var(--bs-border-color, #dee2e6);
}

.segWrap {
  position: absolute;
  top: 4px;
}

.drop {
  display: block;
}

.segBar {
  display: flex;
  align-items: stretch;
  border-radius: 4px;
  color: #3d2f28;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  cursor: grab;
  user-select: none;
  overflow: hidden;
}

.read .segBar {
  cursor: pointer;
  touch-action: manipulation;
  transition: opacity 0.15s;
}
.read .barContent {
  padding-left: 6px;
}
.read .segBar.done {
  opacity: 0.25;
}

.color0 {
  background-color: #f2c6c6;
}

.color1 {
  background-color: #f2e0b0;
}

.color2 {
  background-color: #c6e0c6;
}

.color3 {
  background-color: #c6d2ec;
}

.color4 {
  background-color: #dec6ec;
}

.color5 {
  background-color: #ecc6dc;
}

.color6 {
  background-color: #c6e8e8;
}

.color7 {
  background-color: #e2ecb4;
}

.color8 {
  background-color: #eccbb4;
}

.color9 {
  background-color: #cac6ec;
}

.grip {
  flex-shrink: 0;
  width: 5px;
  align-self: stretch;
  background-color: rgba(0, 0, 0, 0.1);
}

.barContent {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2px 6px 2px 0;
  overflow: hidden;
}

.barLabel {
  font-size: 0.72rem;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.barIngredients {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 2px;
}

.resize {
  position: absolute;
  top: 0;
  right: -6px;
  bottom: 0;
  width: 12px;
  cursor: col-resize;
  touch-action: none;
}
.resize::after {
  content: "";
  display: block;
  width: 2px;
  height: 100%;
  margin: 0 auto;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 1px;
}

.segBody {
  display: flex;
  flex-direction: column;
}

.segTop {
  display: flex;
  align-items: center;
  gap: 4px;
}

.kindToggle {
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0 2px;
  opacity: 0.8;
}

.labelInput {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 0.85rem;
  color: inherit;
  outline: none;
  border-bottom: 1px dashed transparent;
}
.labelInput:focus {
  border-bottom-color: currentColor;
}

.remove {
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0 2px;
  opacity: 0.7;
}
.remove:hover {
  opacity: 1;
}

.segTimes {
  display: flex;
  gap: 8px;
  margin-top: 6px;
}

.timeField {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}
.timeField input {
  width: 56px;
  border: 1px solid var(--bs-border-color, #dee2e6);
  background: transparent;
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 0.78rem;
  color: inherit;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  appearance: textfield;
}
.timeField input::-webkit-inner-spin-button, .timeField input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.timeField .timeUnit {
  font-size: 0.7rem;
  opacity: 0.7;
}

.segIng {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 0 5px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.55);
  font-size: 0.68rem;
  line-height: 1.3;
  white-space: nowrap;
}

.segIngRemove {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  opacity: 0.6;
  font-size: 0.7rem;
}
.segIngRemove:hover {
  opacity: 1;
}

.popoverBackdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
}

.popover {
  position: fixed;
  z-index: 2001;
  width: 300px;
  background: var(--bs-body-bg, #fff);
  color: var(--bs-body-color, #212529);
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  padding: 8px 10px;
}

.popoverHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.popoverTitle {
  font-size: 0.78rem;
  opacity: 0.7;
}

.popoverClose {
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0.6;
}
.popoverClose:hover {
  opacity: 1;
}

:global(.dark) .segBar {
  color: #f0ecea;
}

:global(.dark) .color0 {
  background-color: #8a4a4a;
}

:global(.dark) .color1 {
  background-color: #8a7440;
}

:global(.dark) .color2 {
  background-color: #447344;
}

:global(.dark) .color3 {
  background-color: #445a8a;
}

:global(.dark) .color4 {
  background-color: #64448a;
}

:global(.dark) .color5 {
  background-color: #8a4464;
}

:global(.dark) .color6 {
  background-color: #447a7a;
}

:global(.dark) .color7 {
  background-color: #748a40;
}

:global(.dark) .color8 {
  background-color: #8a6040;
}

:global(.dark) .color9 {
  background-color: #5a548a;
}

:global(.dark) .grip {
  background-color: rgba(255, 255, 255, 0.16);
}

:global(.dark) .resize::after {
  background-color: rgba(255, 255, 255, 0.35);
}

:global(.dark) .popover {
  background: #1e2227;
  color: #d8d8d8;
}

:global(.dark) .popover .timeField input {
  border-color: rgba(255, 255, 255, 0.25);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lYWxUaW1lbGluZS5zYXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWVBO0VBQ0U7OztBQUVGO0VBQ0U7OztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7O0FBRUo7RUFDRTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7OztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0EsT0EzR0s7RUE0R0w7RUFDQTtFQUNBO0VBQ0E7OztBQUdBO0VBQ0U7RUFDQTtFQUNBOztBQUNGO0VBQ0U7O0FBQ0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBREY7RUFDRTs7O0FBREY7RUFDRTs7O0FBREY7RUFDRTs7O0FBREY7RUFDRTs7O0FBREY7RUFDRTs7O0FBREY7RUFDRTs7O0FBREY7RUFDRTs7O0FBREY7RUFDRTs7O0FBREY7RUFDRTs7O0FBRUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUVKO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7O0FBRUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7O0FBRUo7RUFDRTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTtFQUNBOztBQUNBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBQ0E7RUFFRTtFQUNBOztBQUNKO0VBQ0U7RUFDQTs7O0FBRUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7OztBQUVKO0VBQ0U7RUFDQTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUNBO0VBQ0U7OztBQUVKO0VBQ0UsT0F0U1U7OztBQXlTVjtFQUNFOzs7QUFERjtFQUNFOzs7QUFERjtFQUNFOzs7QUFERjtFQUNFOzs7QUFERjtFQUNFOzs7QUFERjtFQUNFOzs7QUFERjtFQUNFOzs7QUFERjtFQUNFOzs7QUFERjtFQUNFOzs7QUFERjtFQUNFOzs7QUFFSjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyJAdXNlIFwic2FzczpsaXN0XCJcblxuJHBhc3RlbC1saWdodDogKFxuICAjZjJjNmM2LCAjZjJlMGIwLCAjYzZlMGM2LCAjYzZkMmVjLCAjZGVjNmVjLFxuICAjZWNjNmRjLCAjYzZlOGU4LCAjZTJlY2I0LCAjZWNjYmI0LCAjY2FjNmVjXG4pXG4kcGFzdGVsLWRhcms6IChcbiAgIzhhNGE0YSwgIzhhNzQ0MCwgIzQ0NzM0NCwgIzQ0NWE4YSwgIzY0NDQ4YSxcbiAgIzhhNDQ2NCwgIzQ0N2E3YSwgIzc0OGE0MCwgIzhhNjA0MCwgIzVhNTQ4YVxuKVxuXG4kYm9yZGVyOiB2YXIoLS1icy1ib3JkZXItY29sb3IsICNkZWUyZTYpXG4kdGV4dDogIzNkMmYyOFxuJHRleHQtZGFyazogI2YwZWNlYVxuXG4ucm9vdFxuICBwYWRkaW5nOiA0cHggMFxuXG4udG9vbGJhclxuICBtYXJnaW4tYm90dG9tOiA4cHhcblxuLmFkZEJ1dHRvblxuICBkaXNwbGF5OiBpbmxpbmUtZmxleFxuICBhbGlnbi1pdGVtczogY2VudGVyXG4gIGdhcDogNnB4XG4gIGJvcmRlcjogMXB4IHNvbGlkICRib3JkZXJcbiAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnRcbiAgYm9yZGVyLXJhZGl1czogNHB4XG4gIHBhZGRpbmc6IDRweCAxMHB4XG4gIGZvbnQtc2l6ZTogMC44NXJlbVxuICBjb2xvcjogdmFyKC0tYnMtYm9keS1jb2xvciwgIzIxMjUyOSlcbiAgY3Vyc29yOiBwb2ludGVyXG4gICY6aG92ZXJcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDEyNywgMTI3LCAxMjcsIDAuMTIpXG5cbi5wYWxldHRlXG4gIG1hcmdpbi1ib3R0b206IDhweFxuXG4ucGFsZXR0ZUhpbnRcbiAgZm9udC1zaXplOiAwLjc1cmVtXG4gIG9wYWNpdHk6IDAuN1xuICBtYXJnaW4tYm90dG9tOiA0cHhcblxuLnBhbGV0dGVDaGlwc1xuICBkaXNwbGF5OiBmbGV4XG4gIGZsZXgtd3JhcDogd3JhcFxuICBnYXA6IDZweFxuXG4uY2hpcFxuICBkaXNwbGF5OiBpbmxpbmUtZmxleFxuICBhbGlnbi1pdGVtczogY2VudGVyXG4gIGdhcDogNnB4XG4gIHBhZGRpbmc6IDJweCA4cHhcbiAgYm9yZGVyLXJhZGl1czogMTJweFxuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDEyNywgMTI3LCAxMjcsIDAuMTQpXG4gIGNvbG9yOiB2YXIoLS1icy1ib2R5LWNvbG9yLCAjMjEyNTI5KVxuICBmb250LXNpemU6IDAuOHJlbVxuICBjdXJzb3I6IGdyYWJcbiAgdXNlci1zZWxlY3Q6IG5vbmVcbiAgdG91Y2gtYWN0aW9uOiBub25lXG5cbi5jaGlwTmFtZVxuICBtYXgtd2lkdGg6IDE0MHB4XG4gIG92ZXJmbG93OiBoaWRkZW5cbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXNcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcFxuXG4uY2FudmFzXG4gIHBvc2l0aW9uOiByZWxhdGl2ZVxuICBtYXgtd2lkdGg6IDEwMCVcbiAgb3ZlcmZsb3cteDogYXV0b1xuICBvdmVyZmxvdy15OiBoaWRkZW5cbiAgYm9yZGVyOiAxcHggc29saWQgJGJvcmRlclxuICBib3JkZXItcmFkaXVzOiA0cHhcblxuLmF4aXNcbiAgcG9zaXRpb246IHJlbGF0aXZlXG4gIGhlaWdodDogMjBweFxuICBib3JkZXItYm90dG9tOiAxcHggc29saWQgJGJvcmRlclxuXG4udGlja1xuICBwb3NpdGlvbjogYWJzb2x1dGVcbiAgdG9wOiAwXG4gIGhlaWdodDogMjBweFxuICBib3JkZXItbGVmdDogMXB4IHNvbGlkICRib3JkZXJcblxuLnRpY2tNaW5vclxuICBwb3NpdGlvbjogYWJzb2x1dGVcbiAgYm90dG9tOiAwXG4gIGhlaWdodDogNHB4XG4gIGJvcmRlci1sZWZ0OiAxcHggc29saWQgJGJvcmRlclxuXG4udGlja0xhYmVsXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZVxuICB0b3A6IDJweFxuICBsZWZ0OiA0cHhcbiAgZm9udC1zaXplOiAwLjYycmVtXG4gIG9wYWNpdHk6IDAuNlxuICB3aGl0ZS1zcGFjZTogbm93cmFwXG5cbi5tYXJrZXJTdHJpcFxuICBwb3NpdGlvbjogcmVsYXRpdmVcbiAgYm9yZGVyLWJvdHRvbTogMXB4IGRhc2hlZCAkYm9yZGVyXG5cbi5sYW5lXG4gIHBvc2l0aW9uOiByZWxhdGl2ZVxuICBib3JkZXItYm90dG9tOiAxcHggc29saWQgJGJvcmRlclxuXG4uc2VnV3JhcFxuICBwb3NpdGlvbjogYWJzb2x1dGVcbiAgdG9wOiA0cHhcblxuLmRyb3BcbiAgZGlzcGxheTogYmxvY2tcblxuLnNlZ0JhclxuICBkaXNwbGF5OiBmbGV4XG4gIGFsaWduLWl0ZW1zOiBzdHJldGNoXG4gIGJvcmRlci1yYWRpdXM6IDRweFxuICBjb2xvcjogJHRleHRcbiAgYm94LXNoYWRvdzogMCAxcHggMnB4IHJnYmEoMCwgMCwgMCwgMC4xNSlcbiAgY3Vyc29yOiBncmFiXG4gIHVzZXItc2VsZWN0OiBub25lXG4gIG92ZXJmbG93OiBoaWRkZW5cblxuLnJlYWRcbiAgLnNlZ0JhclxuICAgIGN1cnNvcjogcG9pbnRlclxuICAgIHRvdWNoLWFjdGlvbjogbWFuaXB1bGF0aW9uXG4gICAgdHJhbnNpdGlvbjogb3BhY2l0eSAwLjE1c1xuICAuYmFyQ29udGVudFxuICAgIHBhZGRpbmctbGVmdDogNnB4XG4gIC5zZWdCYXIuZG9uZVxuICAgIG9wYWNpdHk6IDAuMjVcblxuQGZvciAkaSBmcm9tIDEgdGhyb3VnaCAxMFxuICAuY29sb3IjeyRpIC0gMX1cbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiBsaXN0Lm50aCgkcGFzdGVsLWxpZ2h0LCAkaSlcblxuLmdyaXBcbiAgZmxleC1zaHJpbms6IDBcbiAgd2lkdGg6IDVweFxuICBhbGlnbi1zZWxmOiBzdHJldGNoXG4gIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMCwgMCwgMCwgMC4xMClcblxuLmJhckNvbnRlbnRcbiAgZmxleDogMVxuICBtaW4td2lkdGg6IDBcbiAgZGlzcGxheTogZmxleFxuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uXG4gIGp1c3RpZnktY29udGVudDogY2VudGVyXG4gIHBhZGRpbmc6IDJweCA2cHggMnB4IDBcbiAgb3ZlcmZsb3c6IGhpZGRlblxuXG4uYmFyTGFiZWxcbiAgZm9udC1zaXplOiAwLjcycmVtXG4gIGxpbmUtaGVpZ2h0OiAxLjJcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcFxuICBvdmVyZmxvdzogaGlkZGVuXG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzXG5cbi5iYXJJbmdyZWRpZW50c1xuICBkaXNwbGF5OiBmbGV4XG4gIGZsZXgtd3JhcDogd3JhcFxuICBnYXA6IDJweFxuICBtYXJnaW4tdG9wOiAycHhcblxuLnJlc2l6ZVxuICBwb3NpdGlvbjogYWJzb2x1dGVcbiAgdG9wOiAwXG4gIHJpZ2h0OiAtNnB4XG4gIGJvdHRvbTogMFxuICB3aWR0aDogMTJweFxuICBjdXJzb3I6IGNvbC1yZXNpemVcbiAgdG91Y2gtYWN0aW9uOiBub25lXG4gICY6OmFmdGVyXG4gICAgY29udGVudDogJydcbiAgICBkaXNwbGF5OiBibG9ja1xuICAgIHdpZHRoOiAycHhcbiAgICBoZWlnaHQ6IDEwMCVcbiAgICBtYXJnaW46IDAgYXV0b1xuICAgIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMCwgMCwgMCwgMC4yNSlcbiAgICBib3JkZXItcmFkaXVzOiAxcHhcblxuLnNlZ0JvZHlcbiAgZGlzcGxheTogZmxleFxuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uXG5cbi5zZWdUb3BcbiAgZGlzcGxheTogZmxleFxuICBhbGlnbi1pdGVtczogY2VudGVyXG4gIGdhcDogNHB4XG5cbi5raW5kVG9nZ2xlXG4gIGJvcmRlcjogbm9uZVxuICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudFxuICBjb2xvcjogaW5oZXJpdFxuICBjdXJzb3I6IHBvaW50ZXJcbiAgcGFkZGluZzogMCAycHhcbiAgb3BhY2l0eTogMC44XG5cbi5sYWJlbElucHV0XG4gIGZsZXg6IDFcbiAgbWluLXdpZHRoOiAwXG4gIGJvcmRlcjogbm9uZVxuICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudFxuICBmb250LXNpemU6IDAuODVyZW1cbiAgY29sb3I6IGluaGVyaXRcbiAgb3V0bGluZTogbm9uZVxuICBib3JkZXItYm90dG9tOiAxcHggZGFzaGVkIHRyYW5zcGFyZW50XG4gICY6Zm9jdXNcbiAgICBib3JkZXItYm90dG9tLWNvbG9yOiBjdXJyZW50Q29sb3JcblxuLnJlbW92ZVxuICBib3JkZXI6IG5vbmVcbiAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnRcbiAgY29sb3I6IGluaGVyaXRcbiAgY3Vyc29yOiBwb2ludGVyXG4gIHBhZGRpbmc6IDAgMnB4XG4gIG9wYWNpdHk6IDAuN1xuICAmOmhvdmVyXG4gICAgb3BhY2l0eTogMVxuXG4uc2VnVGltZXNcbiAgZGlzcGxheTogZmxleFxuICBnYXA6IDhweFxuICBtYXJnaW4tdG9wOiA2cHhcblxuLnRpbWVGaWVsZFxuICBkaXNwbGF5OiBpbmxpbmUtZmxleFxuICBhbGlnbi1pdGVtczogY2VudGVyXG4gIGdhcDogMnB4XG4gIGlucHV0XG4gICAgd2lkdGg6IDU2cHhcbiAgICBib3JkZXI6IDFweCBzb2xpZCAkYm9yZGVyXG4gICAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnRcbiAgICBib3JkZXItcmFkaXVzOiAzcHhcbiAgICBwYWRkaW5nOiAycHggNnB4XG4gICAgZm9udC1zaXplOiAwLjc4cmVtXG4gICAgY29sb3I6IGluaGVyaXRcbiAgICAtd2Via2l0LWFwcGVhcmFuY2U6IG5vbmVcbiAgICAtbW96LWFwcGVhcmFuY2U6IHRleHRmaWVsZFxuICAgIGFwcGVhcmFuY2U6IHRleHRmaWVsZFxuICAgICY6Oi13ZWJraXQtaW5uZXItc3Bpbi1idXR0b24sXG4gICAgJjo6LXdlYmtpdC1vdXRlci1zcGluLWJ1dHRvblxuICAgICAgLXdlYmtpdC1hcHBlYXJhbmNlOiBub25lXG4gICAgICBtYXJnaW46IDBcbiAgLnRpbWVVbml0XG4gICAgZm9udC1zaXplOiAwLjdyZW1cbiAgICBvcGFjaXR5OiAwLjdcblxuLnNlZ0luZ1xuICBkaXNwbGF5OiBpbmxpbmUtZmxleFxuICBhbGlnbi1pdGVtczogY2VudGVyXG4gIGdhcDogMnB4XG4gIHBhZGRpbmc6IDAgNXB4XG4gIGJvcmRlci1yYWRpdXM6IDhweFxuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuNTUpXG4gIGZvbnQtc2l6ZTogMC42OHJlbVxuICBsaW5lLWhlaWdodDogMS4zXG4gIHdoaXRlLXNwYWNlOiBub3dyYXBcblxuLnNlZ0luZ1JlbW92ZVxuICBib3JkZXI6IG5vbmVcbiAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnRcbiAgcGFkZGluZzogMFxuICBjdXJzb3I6IHBvaW50ZXJcbiAgb3BhY2l0eTogMC42XG4gIGZvbnQtc2l6ZTogMC43cmVtXG4gICY6aG92ZXJcbiAgICBvcGFjaXR5OiAxXG5cbi5wb3BvdmVyQmFja2Ryb3BcbiAgcG9zaXRpb246IGZpeGVkXG4gIGluc2V0OiAwXG4gIHotaW5kZXg6IDIwMDBcblxuLnBvcG92ZXJcbiAgcG9zaXRpb246IGZpeGVkXG4gIHotaW5kZXg6IDIwMDFcbiAgd2lkdGg6IDMwMHB4XG4gIGJhY2tncm91bmQ6IHZhcigtLWJzLWJvZHktYmcsICNmZmYpXG4gIGNvbG9yOiB2YXIoLS1icy1ib2R5LWNvbG9yLCAjMjEyNTI5KVxuICBib3JkZXI6IDFweCBzb2xpZCAkYm9yZGVyXG4gIGJvcmRlci1yYWRpdXM6IDZweFxuICBib3gtc2hhZG93OiAwIDZweCAyMHB4IHJnYmEoMCwgMCwgMCwgMC4yNSlcbiAgcGFkZGluZzogOHB4IDEwcHhcblxuLnBvcG92ZXJIZWFkZXJcbiAgZGlzcGxheTogZmxleFxuICBhbGlnbi1pdGVtczogY2VudGVyXG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlblxuICBtYXJnaW4tYm90dG9tOiA0cHhcblxuLnBvcG92ZXJUaXRsZVxuICBmb250LXNpemU6IDAuNzhyZW1cbiAgb3BhY2l0eTogMC43XG5cbi5wb3BvdmVyQ2xvc2VcbiAgYm9yZGVyOiBub25lXG4gIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50XG4gIGN1cnNvcjogcG9pbnRlclxuICBvcGFjaXR5OiAwLjZcbiAgJjpob3ZlclxuICAgIG9wYWNpdHk6IDFcblxuOmdsb2JhbCguZGFyaykgLnNlZ0JhclxuICBjb2xvcjogJHRleHQtZGFya1xuXG5AZm9yICRpIGZyb20gMSB0aHJvdWdoIDEwXG4gIDpnbG9iYWwoLmRhcmspIC5jb2xvciN7JGkgLSAxfVxuICAgIGJhY2tncm91bmQtY29sb3I6IGxpc3QubnRoKCRwYXN0ZWwtZGFyaywgJGkpXG5cbjpnbG9iYWwoLmRhcmspIC5ncmlwXG4gIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC4xNilcblxuOmdsb2JhbCguZGFyaykgLnJlc2l6ZTo6YWZ0ZXJcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjM1KVxuXG46Z2xvYmFsKC5kYXJrKSAucG9wb3ZlclxuICBiYWNrZ3JvdW5kOiAjMWUyMjI3XG4gIGNvbG9yOiAjZDhkOGQ4XG5cbjpnbG9iYWwoLmRhcmspIC5wb3BvdmVyIC50aW1lRmllbGQgaW5wdXRcbiAgYm9yZGVyLWNvbG9yOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMjUpXG4iXX0= */